import { combineReducers, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist'; // NOTE: se usa para mantener los valores de store incluso al refrescar las páginas
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import { alertReducer } from '../reducers/alertReducers';
import { userReducer } from '../reducers/authReducers';
import { loadingReducer } from '../reducers/loadingReducers';
import { websocketReducer } from '../reducers/websocketReducer';

const persistConfig = {
	key: 'root',
	storage,
	blacklist: ['ui'], // reducers que no deben persistir
};

const reducers = combineReducers({
	uReducer: userReducer,
	wsReducer: websocketReducer,
	ui: combineReducers({
		ialert: alertReducer,
		loading: loadingReducer,
	}),
});

const pReducer = persistReducer(persistConfig, reducers);

export const store = createStore(pReducer);
export const persistor = persistStore(store);
